import { Injectable } from '@angular/core';
import { CHANNELS_ENUMERATION, MarketingEventEnumeration } from './configs';

interface DataLayerType {
  event: string;
  payload?: Record<string, unknown>;
}

interface EventChannelType {
  postMessage: (message: string) => void;
}

declare global {
  interface Window {
    dataLayer: DataLayerType[];
    APP_CHANNEL_RC: EventChannelType;
    CLOSE_CHANNEL_RC: EventChannelType;
  }
}

@Injectable({
  providedIn: 'root',
})
export class MarketingEventService {
  public sendMarketingEvents(eventName: MarketingEventEnumeration) {
    const event: DataLayerType = { event: eventName };
    this.notifyEventToDataLayer(event);
    this.notifyEventToChannel(CHANNELS_ENUMERATION.APP_CHANNEL, event);
  }

  private notifyEventToDataLayer(event: DataLayerType): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }

  public notifyEventToChannel(channel: CHANNELS_ENUMERATION, event: DataLayerType): void {
    if (this.channelExists(channel)) {
      window[channel].postMessage(JSON.stringify(event));
    }
  }

  private channelExists(channel: CHANNELS_ENUMERATION): boolean {
    return typeof window[channel] !== 'undefined';
  }
}
